"use client";

import { useMemo, useState } from "react";
import { calcRisk } from "@/lib/tools/risk";
import { formatUsd } from "@/lib/utils";
import { Field, NumberInput, Out } from "@/components/tools/form-controls";

export function RiskClient() {
  const [accountSize, setAccountSize] = useState(100_000);
  const [riskPct, setRiskPct] = useState(1);
  const [entry, setEntry] = useState(100);
  const [stop, setStop] = useState(99);

  const result = useMemo(
    () => calcRisk({ accountSizeUsd: accountSize, riskPct, entryPrice: entry, stopPrice: stop }),
    [accountSize, riskPct, entry, stop],
  );

  return (
    <div className="space-y-6">
      <Field label="Account size (USD)">
        <NumberInput value={accountSize} onChange={setAccountSize} step={1000} min={100} />
      </Field>
      <Field label="Risk per trade (%)">
        <NumberInput value={riskPct} onChange={setRiskPct} step={0.1} min={0.01} max={10} />
      </Field>
      <div className="grid grid-cols-2 gap-4">
        <Field label="Entry price">
          <NumberInput value={entry} onChange={setEntry} step={0.01} />
        </Field>
        <Field label="Stop price">
          <NumberInput value={stop} onChange={setStop} step={0.01} />
        </Field>
      </div>

      <div className="rounded-[var(--radius)] border border-[var(--border)] bg-[var(--surface)] p-6">
        <div className="grid grid-cols-2 gap-4 text-sm">
          <Out label="Risk in $" value={formatUsd(result.riskUsd)} />
          <Out label="Stop distance" value={result.stopDistance.toFixed(2)} />
          <Out
            label="Position units"
            value={result.positionUnits.toLocaleString(undefined, { maximumFractionDigits: 4 })}
            highlight
          />
          <Out label="Notional" value={formatUsd(result.notionalUsd)} />
        </div>
        {result.warnings.length > 0 ? (
          <ul className="mt-4 space-y-1 text-sm text-amber-400">
            {result.warnings.map((w, i) => (
              <li key={i}>{w}</li>
            ))}
          </ul>
        ) : null}
      </div>
    </div>
  );
}
